import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from '../../app.config';
import { MessageService } from '../../core/service/message.service';
import { ProgressBarService } from '../../core/service/progress-bar.service';
import { DataService } from '../../core/service/base/data.service';
import { Observable } from 'rxjs';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import { CompanyMortgage } from '../model/company-mortgage';
import { CompanyMortgageFilter } from '../model/company-mortgage-filter';
import { PagedFilter } from '../../core/model/paged-filter';
import { Money } from '../../core/model/money';
import { LocalDate } from '../../core/model/local-date';
import { CompanyMortgageAmortization } from '../model/company-mortgage-amortization';

@Injectable()
export class CompanyMortgageService extends DataService<CompanyMortgage> {
  getAmortizations(id: string): Observable<CompanyMortgageAmortization[]> {
    return this.client.get<CompanyMortgageAmortization[]>(`${this.endpoint}/${id}/amortizations`);
  }
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, CompanyMortgage, progressBar, 'company-mortgage');
  }

  addAmortization(id: string, amount: Money, paymentDate: LocalDate): Observable<CompanyMortgage> {
    return this.client
      .post<CompanyMortgage>(`${this.endpoint}/add-amortization`, { companyMortgageId: id, amount: amount, paymentDate: paymentDate })
      .pipe(
        map(res => new CompanyMortgage(res)),
        catchError(error => {
          this.notification.showError(error);
          throw error;
        })
      );
  }

  getFilterDefinition(): Observable<PagedFilter<CompanyMortgageFilter>> {
    return this.client.get<PagedFilter<CompanyMortgageFilter>>(`${this.endpoint}/filter`).pipe(
      map(res => {
        let result = res;
        if (!result.filter.selectedFields || result.filter.selectedFields.length === 0) {
          result.filter.selectedFields = ['companyId', 'creditInstituteId', 'name'];
        }

        return result;
      }),
      catchError(error => {
        console.log(error);
        return [];
      })
    );
  }
}
